import {NormalizerI} from './normalizer.i';
import {isString} from 'lodash';

const EMPTY = '';

export class IntegerNormalizer implements NormalizerI {

    normalize(value: string): string {

        if (!isString(value)) {
            return null;
        }

        return value.replace(/[^0-9]/g, EMPTY);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/normalizers/integer.normalizer.ts